 
import React from 'react';
import BootstrapModal from 'react-bootstrap/Modal';

import * as Styles from './styles';

export default function Modal({
  show,
  handleClose,
  heading,
  body,
  footer,
  closeButton = true,
  notClosed = true,
  ...props
}) {
  return (
    <Styles.StyledModal show={show} onHide={handleClose} {...props}>
      {heading && notClosed ? (
        <BootstrapModal.Header closeButton={closeButton}>
          <BootstrapModal.Title>{heading}</BootstrapModal.Title>
        </BootstrapModal.Header>
      ) : (
        <BootstrapModal.Header>
          <BootstrapModal.Title>{heading}</BootstrapModal.Title>
        </BootstrapModal.Header>
      )}
      {body && <Styles.StyledModalBody className="pt-3 px-5">{body}</Styles.StyledModalBody>}
      {footer && <BootstrapModal.Footer className="py-3 px-5">{footer}</BootstrapModal.Footer>}
    </Styles.StyledModal>
  );
}
